<template lang="pug">
app-layout
  v-container
    v-snackbar(:value="!!errorMessage" color="error")
        div {{ errorMessage }}
    div.resend-email-container
      div.container-item
        v-img(src="/static/img/ld-powered-lw-logo.svg" height="50" contain)
      div.container-item.extra-padding
        v-img(src="/static/img/open-email-logo.svg" height="100" contain)
      div.resend-email-container
        div.container-item.subtitle(v-if="isDialerEmailValid") Email dialer has been verified
        div.container-item.subtitle(v-else-if="errorMessage") Email could not be verified
        div.container-item.subtitle(v-else) Verifying email dialer
        div.container-item.extra-padding
        p.mb-0 If you experience difficulties, please reach out to our support department at 
          a(:href="contactSupportLink") support@liondesk.com
          span  for assistance.
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const {
  mapState: mapDialerState,
  mapGetters: mapDialerGetters,
  mapActions: mapDialerActions,
} = createNamespacedHelpers('dialer');
export default {
  name: 'VerifyEmailDialer',
  async mounted() {
    const { token } = this.$route.query;
    if (!token) {
      return;
    }
    await this.verifyEmailDialer(token);
  },
  beforeDestroy() {
    this.clearDialerEmailError();
  },
  computed: {
    ...mapDialerState({
      isLoading: state => state.email.isLoading,
      errorMessage: state => state.email.error,
    }),
    ...mapDialerGetters(['isDialerEmailValid']),
    contactSupportLink() {
      if (!this.errorMessage) {
        return `mailto:support@liondesk.com`;
      }
      const subject = encodeURIComponent(`Verify Email Dialer Error`);
      const body = encodeURIComponent(
        `The error ${this.errorMessage} has ocurred while verifying the email dialer.`,
      );
      return `mailto:support@liondesk.com?subject=${subject}&body=${body}`;
    },
  },
  methods: {
    ...mapDialerActions(['verifyEmailDialer', 'clearDialerEmailError']),
  },
};
</script>
<style lang="scss" scoped>
.resend-email-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  width: 100%;

  .container-item {
    margin-bottom: 25px;
    width: 50%;
    max-width: 500px;
  }

  .subtitle {
    font-size: 32px;
    color: #235ea1;
  }

  .extra-padding {
    padding-top: 5%;
  }

  .rounded-button {
    text-transform: none;
    border-radius: 5px;
  }
}
</style>